import { useMemo } from 'react';
import { useAuth } from '../auth/AuthContext';
import { buildUserLearningContext, type UserLearningContextOptions } from '@examflow/learning-space';

export function useLearningViewer(options: UserLearningContextOptions = {}) {
  const { user, entitlements } = useAuth();
  const { examType, languageId } = options;

  return useMemo(
    () => buildUserLearningContext(user, entitlements, { examType, languageId }),
    [entitlements, examType, languageId, user]
  );
}
